import { Producto } from '@/interface/producto.model';
import { Component } from '@angular/core';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-productos-delivery',
  templateUrl: './productos-delivery.component.html',
  styleUrls: ['./productos-delivery.component.scss']
})
export class ProductosDeliveryComponent {
  rows: Array<Producto>;
  tempRows: Array<Producto>;

  constructor(
    public generalService: GeneralService,
    private toastr: ToastrService,
    private loadingService: LoadingService) { }

  async ngOnInit() {
    await this.getData();
  }

  async getData() {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getListar("producto/delivery")
      this.rows = res.data;
      this.tempRows = res.data;
      this.loadingService.setLoading(false)

    } catch (error) {
      this.loadingService.setLoading(false)
    }
  }
}
